module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Marrakesh.bcf67e12.jpg";